export const Select = {
  baseStyle: {
    fontWeight: '500',
    borderRadius: 'base',
  },
};
